





















import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CONFIG from "@/common/config";

import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';

@Component
export default class BGMIcon extends Vue {
  @Getter("inviteIcon") inviteIcon!: string;
  
  getUrlParam: Function = getUrlParam;

  // 转介绍跳转
  handletoRefer(): void {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const referralId: string = getUrlParam("referralId") as string;
    const promoterId: string = getUrlParam("promoterId") as string;
    const referralAppId: string = getUrlParam("referralAppId") as string;
    debugger;
    const url: string =
      (CONFIG.appShowUrl as any)[env] +
      "h5/index.html#/transfer/index/" + referralId +
      "?promoterId=" + promoterId +
      "&appid=" + referralAppId;
    window.location.href = url;
  }
}
